import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import { IModelInfo } from "../../entities/nu-model-info";

@Component
export default class NewModelNodeDialog extends Vue {


    @Prop()
    value: IModelInfo;

    // Todo: Implement

}



// WEBPACK FOOTER //
// ./ClientApp/components/new-model-node-dialog/new-model-node-dialog.ts